import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartState } from '@app/store/state/cart.state';
import { Select } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { I18nService } from '../../../../core';

@Component({
  selector: 'app-header-invitation-b2b',
  templateUrl: './header-invitation-b2b.component.html',
  styleUrls: ['./header-invitation-b2b.component.scss']
})
export class HeaderInvitationB2bComponent implements OnInit, OnDestroy {

  user = window['CONST_USER'];
  currAccount = window['CURRENT_ACCOUNT'];
  config = {
    language: ''
  };
  productName = window.location.host.split('.')[0];
  isMobile = false;
  isTablet = false; // Only used by ttc switch to moove from header if width < 1200px

  @Select(CartState.accounts)
  accounts$: Observable<any>;

  _accounts: any[];

  infomaniakLogoPath = '/assets/images/logo-infomaniak.svg';

  private onDestroy$ = new Subject<boolean>();
  constructor(private router: Router,
    private i18nService: I18nService,
    public breakpointObserver: BreakpointObserver) { }


  ngOnInit() {
    this.config.language = this.currentLanguage;

    this.breakpointObserver.observe([
      '(max-width: 767px)'
    ]).pipe(takeUntil(this.onDestroy$)).subscribe(result => {
      if (result.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
    this.breakpointObserver.observe([
      '(max-width: 1200px)'
    ]).pipe(takeUntil(this.onDestroy$)).subscribe(result => {
      if (result.matches) {
        this.isTablet = true;
      } else {
        this.isTablet = false;
      }
    });


    this.accounts$.pipe(takeUntil(this.onDestroy$)).subscribe(accounts => {
      this._accounts = accounts;
    });
  }

  setLanguage(language: string) {
    this.i18nService.setLanguage(language, true);
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  getInitial() {
    const displayName = this.user.first_name?.trim() + ' ' + this.user.last_name?.trim();
    const splitted = displayName.split(' ');
    return (splitted[0].length > 0 ? splitted[0][0].toUpperCase() : '') + (splitted[splitted.length - 1].length > 0 ? splitted[splitted.length - 1][0].toUpperCase() : '');
  }


  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  switchLink(links) {
    if (Object.keys(window['CONST_USER']).length > 0) {
      return links?.manager || 'https://manager.infomaniak.com';
    } else {
      return links.hosting;
    }
  }
}
